<template>
  <v-container fill-height fluid >
    <v-col>
      <v-row
        align="center"
        justify="center"
      >
        <v-img
          :src="process_map_image"
          class="my-3"
          contain
          max-height="720px"
          v-if="!!process_map_image"
        ></v-img>
        <v-card
          v-else
          elevation="1"
        >
          <v-card-text>
            {{ $vuetify.lang.translator('no_process_map') }}
          </v-card-text>
        </v-card>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
 import { mapState, mapGetters } from 'vuex';

 export default {
   name: 'Preferences',

   data: () => ({}),

   computed: {
     ...mapGetters(['centro_data']),

     process_map_image() {
       return this.centro_data.process_map_image;
     }
   },
 }
</script>
